module.exports = __webpack_public_path__ + "fonts/Open_Sans-400-cyrillic13.b3501f3.woff2";